import { DatePicker, DatePickerProps } from '@emburse/ui-core';

import * as abacusTimeFormatter from '@Shared/helpers/abacusTimeFormatter';

export const DateOfBirthField: React.FC<DatePickerProps<Date> & { helperText?: string; error?: any }> = ({
  helperText = '',
  error,
  slotProps = {},
  ...rest
}) => {
  const { textField = {}, layout = {}, ...restSlotProps } = slotProps;

  return (
    <DatePicker
      sx={{ width: '100%' }}
      minDate={abacusTimeFormatter.subtractYears(new Date(), 100)}
      maxDate={abacusTimeFormatter.subtractYears(new Date(), 18)}
      slotProps={{
        textField: {
          helperText,
          color: error ? 'error' : '',
          size: 'small',
          focused: error, // force focused state to show error colour
          ...textField
        },
        layout: {
          // fix a weird ui bug where the month picker is smaller than the year/ day picker - enforce the same height for all 3 views
          // ie: by default, DatePicker will try to spawn the date dialog at the bottom, however if there isn't enough space, it will spawn at the top
          // the problem is that sometimes the year/ day cannot fit at the bottom but the month can
          // this auto closes the dialog without the user being able to pick the date
          // with the height enforced to be the same, the dialog will always spawn at the same place
          sx: { minHeight: '360px' },
          ...layout
        },
        ...restSlotProps
      }}
      openTo="year"
      views={['year', 'month', 'day']}
      {...rest}
    />
  );
};
